import {createSelector, MemoizedSelector} from '@ngrx/store';
import {Mensaje, mensajesAdapter, MensajesState} from './mensajes.state';

import {FeaturesState, selectFeatures} from '../../../features.state';

export const getError = (state: MensajesState): any => state.error;

export const getIsLoading = (state: MensajesState): boolean =>
  state.isLoading;

export const selectMensajesState = createSelector(selectFeatures,
  (state: FeaturesState) => state.mensajes
);

export const selectAllMensaje: (state: object) =>
  Mensaje[] = mensajesAdapter.getSelectors(selectMensajesState).selectAll;

export const selectMensajesError: MemoizedSelector<object, any> =
  createSelector(selectMensajesState, getError);

export const selectMensajesIsLoading: MemoizedSelector<object, boolean> =
  createSelector(selectMensajesState, getIsLoading);
